import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
    ItemsListHeadItemLabelComponent,
    ItemsListHeadItemLabelComponent_headComponent,
} from '@fi-app/components/items-list/head-item/head-item-label/head-item-label.component';
import { ItemsListHeadItemComponent } from '@fi-app/components/items-list/head-item/head-item.component';

@Component({
    selector: 'fi-statistic2-report-value-header',
    template: `
        <span class="CcmListItemTextOverflow CcmListItemName">
          {{ headerText }}
          <div class="tooltip-wrapper">
            @if (tooltipText) {
              <fi-info-icon
                [fiInfoPosition]="'right-under'"
                [fiInfoPositionMobile]="'top'"
                [isIconTooltipShown]="false"
                [isMaxSize]="true"
                [disableToggleByClick]="true"
                >
                <p>{{ tooltipText }}</p>
              </fi-info-icon>
            }
          </div>
        </span>
        `,
    styleUrls: ['./statistic2-report-value-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class Statistic2ReportValueHeaderComponent extends ItemsListHeadItemLabelComponent {
    headerText: string;
    tooltipText: string;

    constructor(
        @Inject(ItemsListHeadItemLabelComponent_headComponent) public headComponent: ItemsListHeadItemComponent,
    ) {
        super(headComponent);
        this.headerText = headComponent.head.Properties.ExtraProperties.headData.headerText;
        this.tooltipText = headComponent.head.Properties.ExtraProperties.headData.tooltipText;
    }
}
